import Vue from 'vue';
import { $httpChangiRecommends } from '@/core/api';
import BrandsSwiper from '@/components/swiper/BrandsSwiper.vue';
export default Vue.extend({
    components: { BrandsSwiper },
    data() {
        return {
            brands: [],
        };
    },
    created() {
        $httpChangiRecommends.api.ChangiRecommendsCarouselBrands().then((resp) => {
            this.brands = resp.data;
        });
    },
});
